import { getAccountPlanStatusDotClass } from "@/shared/utils/tableConfig";

const StatusDot = ({ color, className = "" }) => (
  <span
    className={`inline-block w-2 h-2 rounded-full flex-shrink-0 ${getAccountPlanStatusDotClass(color)} ${className}`}
    aria-hidden="true"
  />
);

export default StatusDot;
